module.exports = __webpack_public_path__ + "static/img/sftp3.8b65e94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/joinus/sftp3.png
// module id = tg4L
// module chunks = 1